import { render } from "./tab-bar-item.vue?vue&type=template&id=59bbcb9c"
import script from "./tab-bar-item.vue?vue&type=script&setup=true&lang=js"
export * from "./tab-bar-item.vue?vue&type=script&setup=true&lang=js"

import "./tab-bar-item.vue?vue&type=style&index=0&id=59bbcb9c&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/main-layout/components/tab-bar/tab-bar-item.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "59bbcb9c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('59bbcb9c', __exports__)) {
    api.reload('59bbcb9c', __exports__)
  }
  
  module.hot.accept("./tab-bar-item.vue?vue&type=template&id=59bbcb9c", () => {
    api.rerender('59bbcb9c', render)
  })

}


export default __exports__